const baseURL5 = "https://friendsgoldsmith.newfriendsjewellers.com:9096";


export default baseURL5;